var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.458 15c.346 0 .625.28.625.625v.837c0 1.041-.997 1.79-2 1.517a49.434 49.434 0 0 0-13-1.729.625.625 0 0 1 0-1.25 50.685 50.685 0 0 1 13.329 1.773.33.33 0 0 0 .421-.31v-.838c0-.345.28-.625.625-.625zm-13.125-.625h-.312c-.863 0-1.563-.7-1.563-1.563V4.688c0-.862.7-1.562 1.563-1.562h14.375c.821 0 1.495.635 1.558 1.44l.004.122v8.125c0 .863-.7 1.563-1.562 1.563H3.333zm13.125-10h-12.5l-.005.12A1.25 1.25 0 0 1 2.829 5.62l-.12.006v6.25l.12.006a1.25 1.25 0 0 1 1.124 1.124l.005.12h12.5c0-.65.496-1.184 1.13-1.244l.12-.006v-6.25c-.69 0-1.25-.56-1.25-1.25zm-6.25 1.25a3.125 3.125 0 1 1 0 6.25 3.125 3.125 0 0 1 0-6.25zm0 1.25a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75z",
    fill: "#8E06BF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPurple);
export default __webpack_public_path__ + "static/media/cash-purple.4d8f5dfbc7631bba4c493b55da4e7680.svg";
export { ForwardRef as ReactComponent };